import React from "react";
import "./NotificationItemMobile.css";

const NotificationItemMobile = (props) => {
  const limit = 80;
  return (
    <div
      className={
        "notification-list " +
        (props.item.unread && props.item.unread === "true"
          ? "notification-list--unread"
          : "")
      }
      data-testid="notification-item"
    >
      {!props.isNotification && (
        <div className="notification-list_img">
          <img src={props.item.image} alt="user" />
        </div>
      )}
      <div className="notification-list_detail">
        <div>
          {!props.isNotification && <b>{props.item.name}</b>}
          <div data-testid="content-id" className="notif-content">
            {props.item.content.substring(0, limit)}...
          </div>
        </div>
        <p>
          <small>{props.item.duration}</small>
        </p>
      </div>
    </div>
  );
};

export default NotificationItemMobile;
